import { useState } from "react";
import { collection, addDoc, serverTimestamp } from "firebase/firestore"; // Import collection and addDoc
import { db } from "../firebase"; // Import your Firestore instance

const useAddProduct = () => {
  const [isPending, setIsPending] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  /**
   * Adds a new product to a specific list in Firestore.
   * @param {string} listId The ID of the list to add the product to.
   * @param {object} productData The data for the new product (e.g., { name: "Milk", checked: false }).
   */
  const addProduct = async (listId, productData) => {
    setIsPending(true);
    setIsError(false);
    setIsSuccess(false);

    try {
      if (!listId) {
        throw new Error("listId is required to add a product.");
      }
      if (
        !productData ||
        typeof productData !== "object" ||
        !productData.name
      ) {
        throw new Error(
          "Product data with at least a 'name' field is required."
        );
      }

      // Get a reference to the products subcollection within the specified list
      const productsCollectionRef = collection(db, "lists", listId, "products");

      // Add the new product document with an auto-generated ID
      await addDoc(productsCollectionRef, {
        ...productData,
        checked: false,
        createdAt: serverTimestamp(),
      });

      setIsSuccess(true);
      console.log(
        `Product "${productData.name}" added successfully to list ${listId}.`
      );
    } catch (error) {
      setIsError(true);
      console.error("Error adding product:", error);
      throw error; // Re-throw to allow component to catch if needed
    } finally {
      setIsPending(false);
    }
  };

  // Reset status flags
  const resetStatus = () => {
    setIsPending(false);
    setIsError(false);
    setIsSuccess(false);
  };

  return { addProduct, isPending, isError, isSuccess, resetStatus };
};

export default useAddProduct;
